/* ════════════ STAT BARS ════════════
   Fills .bar[data-v] elements with 10 pixel cells, the first data-v
   of them lit. Shared by the langs tier-list page and every language
   dossier page. */

export function fillBars() {
  for (const bar of document.querySelectorAll<HTMLElement>(".bar[data-v]")) {
    const v = Math.max(0, Math.min(10, Number(bar.dataset.v) || 0));
    for (let i = 0; i < 10; i++) {
      const cell = document.createElement("i");
      if (i < v) cell.className = "f";
      bar.appendChild(cell);
    }
  }
}
